export default "__VITE_ASSET__cjezGPha__"